/*eslint-disable no-unused-vars */
import React, { createRef } from 'react';

//Third party packages
import { connect } from 'react-redux';
import { Col, Container, Row } from 'react-bootstrap';
import { Navigate, Link } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

//un-used components but if removed breaks the design
//some of the below un-used component CSS is being used in this module indirectly
//FUTURE: Import the necessary CSS directly
import MenuTabs from './coverage/Coverage';

import { axiosInstance } from 'src/api/axios';
import RetryAPI from 'src/Member/api/RetryAPI';
import Chatbot from 'src/Member/shared/Chatbot';
import Dependent from 'src/Member/api/Dependent';
import Greetings from 'src/Member/shared/greetings';
import Coverage from './newCoverage/Coverage';
import HttpHeader from 'src/Member/shared/httpheader';
import APIEndpoints from 'src/Member/api/APIEndpoints';
import SpendingSummary from './spending/SpendingSummary';
import MemberSummary from 'src/Member/api/MemberSummary';
import { setContentLoader } from 'src/redux/app/appSlice';
import Authenticated from 'src/Member/shared/Authenticated';
import GetRolePermissionAffiliation from 'src/Member/api/GetRolePermissionAffiliation';
import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from 'src/Member/errorhandling/HttpErrorCodes';
import {
  setMemberSummaryReject,
  setMemberSummarySuccess,
  setViewMemberInformationSuccess,
} from 'src/redux/member/memberSlice';
import MasterPermissions from 'src/Member/api/MasterPermissions';
import CustomClientError from '../../errorhandling/CustomClientError';
import { withTranslation } from 'react-i18next';
import CoverageStatus from './coverageStatus/coverageStatus';
import './dashboard.scss';

import { maskedOther } from 'src/common/masking';
library.add(faArrowRight);

class Dashboard extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      MemberID: '',
      FirstName: '',
      DOB: '',
      MenuFlag: false,
      ClaimFlag: false,
      sidemenuPermissions: false,
      DependentsInfo: [],
      Family: 'false',
      isAPIFailed: false,
      isNotFound: false,
      LoggedInMemberOID: null,
      isKeenan: false,
    };
    this.greetingsRef = createRef();
  }

  cacheBuster = (url) => `${url}?cb=${Date.now()}`;

  async componentDidMount() {
    this._isMounted = true;
    this.props.setContentLoader(5);
    //eslint-disable-next-line no-unused-vars
    let response;
    console.log('HttpHeader.getCNAME: ', HttpHeader.getCNAME());
    console.log('HttpHeader.getDevice: ', HttpHeader.getDevice());
    const cName = HttpHeader.getCNAME();
    if (cName.includes('keenan') || cName.includes('tpabenefits')) {
      this.setState({ isKeenan: true });
    }

    //Starting Chatbot
    Chatbot.StartChatbot();

    const permissionLen =
      GetRolePermissionAffiliation.rolePermissionAffiliation?.length;

    if (this.props.user !== null && this._isMounted) {
      await this.getMemberSummary(this.props.user.userData);
    }
    this._isMounted &&
      setTimeout(() => {
        this.greetingsRef.current.focus();
      }, 10);
  }

  componentDidUpdate(prevProps) {
    //Check if the user prop has changed
    if (
      prevProps?.user?.userData?.MemberDetails?.MemberOID !==
        this.props?.user?.userData?.MemberDetails?.MemberOID &&
      this.props.user !== null &&
      this._isMounted
    ) {
      console.log('User details updated, calling getMemberSummary...');
      this.getMemberSummary(this.props.user.userData);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  setMemberSummaryState() {
    const memberSummaryResp = MemberSummary.getMemberSummaryResponse();

    console.log('MemberSummary.getMemberType(): ', memberSummaryResp);
    if (MemberSummary.getMemberType() === 'Employee')
      this.setState({ MemberFlag: true });

    if (MemberSummary.getMemberType() === 'Dependent')
      MemberSummary.setSideMenuPermissions(true);

    this.setState(
      {
        MemberID: memberSummaryResp.Response.Member.CertificateNumber,
        FirstName: memberSummaryResp.Response.Member.FirstName,
        DOB: memberSummaryResp.Response.Member.BirthDate,
        MenuFlag: true,
        DependentsInfo: memberSummaryResp.Response.Member.DependentsInfo,
        Family: memberSummaryResp.Response.Member.Family,
        LoggedInMemberOID: memberSummaryResp.Response.Member.LoggedInUserOID,
      },
      () => {
        MemberSummary.setMemberID(this.state.MemberID);
      },
    );
  }

  getMemberSummary = async (user) => {
    let response;
    try {
      MemberSummary.resetFirstName('MemberFirstName');

      const oidParams = `${
        user?.MemberDetails?.MemberType === 'employee'
          ? 'memberoid'
          : 'dependentoid'
      }/${user?.MemberDetails?.MemberOID}`;

      const dummyData = `oid/${user?.MemberDetails?.MemberOID}/membertype/${user?.MemberDetails?.MemberType}/${oidParams}`;
      const response = await axiosInstance.get(
        APIEndpoints.getMemberSummaryResource() + dummyData,
      );

      const responseMember = await axiosInstance.get(
        APIEndpoints.getViewMemberinformation() + dummyData,
      );

      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        const memberSummaryDataResp = response.data;
        this.props.setMemberSummarySuccess(response.data);
        this.props.setViewMemberInformationSuccess(responseMember.data);
        //Setting Member Summary Response
        MemberSummary.setMemberSummaryResponse(memberSummaryDataResp);
        MemberSummary.parseMemberSummary();
        console.log(MemberSummary.getMemberOID());
        console.log(Dependent.getMemberOID(0));
        this.setMemberSummaryState();

        if (this.props.user.isLoggedIn) {
          Authenticated.setMemberName(this.state.FirstName);
        }
        this.setState({ isAPIFailed: false, isNotfound: false });
      }
    } catch (error) {
      this.setState({ isAPIFailed: true });
      if (error.toString().includes('404')) {
        this.setState({ isNotFound: true });
      }
      this.setState({ MenuFlag: false });
    }
    return response;
  };

  getSideMenuPermissions = () => {
    this.setState({ sidemenuPermissions: true });
  };

  getMemberID = (adminConfigData, employeeInfo, suppressedConfigValue) => {
    const defaultMemberID =
      adminConfigData &&
      adminConfigData?.Response?.AttributeNameConfiguration.filter(
        (item) => item.memberID,
      );
    const str = defaultMemberID && defaultMemberID[0].attributeKey;
    const key = str && str.charAt(0).toUpperCase() + str.slice(1);
    const suppressConfigValue =
      key == 'AlternateID1'
        ? suppressedConfigValue?.altId1
        : key == 'AlternateID2'
        ? suppressedConfigValue?.altId2
        : suppressedConfigValue?.memberId;
    let maskedValue;
    if (
      employeeInfo.LoggedInMemberType === 'Dependent' &&
      this.state.DependentsInfo.length > 0
    ) {
      const dependentDetails = this.state.DependentsInfo.filter(
        (eachDependent) => eachDependent.OID === this.state.LoggedInMemberOID,
      )[0];
      maskedValue = maskedOther(suppressConfigValue, dependentDetails[key]);
    } else {
      maskedValue = maskedOther(suppressConfigValue, employeeInfo[key]);
    }
    return maskedValue;
  };

  render() {
    const height = '360px';
    const width = '';
    const { userData, adminConfigData } = this.props.user;
    const { employeeInfo } = this.props.memberSummaryData;

    const defaultMemberID = this.getMemberID(
      adminConfigData,
      employeeInfo,
      this?.props?.suppressConfigVal,
    );

    const { t } = this.props;

    //if ( this.state.serverError )
    //return ( <Redirect to="/member/server-error" push={true}></Redirect> );

    return (
      <>
        {this.state.isAPIFailed ? (
          <div className="container-offset">
            {this.state.isNotFound ? (
              <Container>
                <CustomClientError
                  ErrorHeading="No data found!"
                  ErrorMessage="The selected member does not have any summary."
                  CustomClasses="p-0 m-0"
                />
              </Container>
            ) : (
              <Container>
                <CustomClientError
                  ErrorHeading="Something went wrong with member summary request!"
                  ErrorMessage="Please try again."
                  CustomClasses="p-0 m-0"
                />
              </Container>
            )}
          </div>
        ) : (
          <>
            <div className="coverage-status-wrapper">
              <CoverageStatus
                clientName={userData?.MemberDetails?.ClientName}
                status={userData?.MemberDetails?.CoverageStatus}
              />
            </div>
            <Container className="dashboard-container">
              <div className="dashboard-navbar">
                <Row aria-live="polite" className="mx-0">
                  <div
                    role="heading"
                    aria-level={1}
                    className="sr-only"
                    tabIndex={-1}
                    ref={this.greetingsRef}
                  >
                    {Greetings.getGreetings()},{' '}
                    <span id="greetings_welcomemsg">
                      {userData.FirstName}{' '}
                      {t('member.dashboard.dashboard_page.welcome_msg')}
                    </span>
                  </div>
                  <h1 id="greetings-time" aria-hidden={true}>
                    {Greetings.getGreetings()},{' '}
                    <span id="greetings">{userData.FirstName}</span>
                  </h1>
                </Row>
                <Row className="d-block mx-0 mt-sm-0 mt-2">
                  <table className="table-borderless m-0">
                    <tbody>
                      <tr>
                        <td className="page-info-line">
                          {defaultMemberID && (
                            <>
                              <span className="page-info-title">
                                {t('member.dashboard.dashboard_page.mem_id')}
                                &nbsp;&nbsp;
                              </span>
                              <span className="page-info-title">
                                {' '}
                                {defaultMemberID}
                              </span>
                            </>
                          )}
                        </td>
                        <td className="page-info-line">
                          {(MasterPermissions.CheckPermission(
                            'View Self Profile Information',
                          ) ||
                            MasterPermissions.CheckPermission(
                              'Change Password',
                            ) ||
                            MasterPermissions.CheckPermission(
                              'Alternate Email',
                            ) ||
                            MasterPermissions.CheckPermission(
                              'View Responsible party Information',
                            ) ||
                            MasterPermissions.CheckPermission(
                              'View HIPAA Patient Rights Information',
                            )) && (
                            <Link to="/member/my-profile" id="message-display">
                              <span>
                                {t(
                                  'member.dashboard.dashboard_page.view_profile',
                                )}
                              </span>
                            </Link>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Row>
                <Row>
                  {this.state.MenuFlag && !this.state.isKeenan && (
                    <Col className="margin-bottom-32" xs={12}>
                      <Coverage
                        DependentsInfo={this.state.DependentsInfo}
                        Family={this.state.Family}
                      />
                    </Col>
                  )}
                  {this.state.MenuFlag && (
                    <SpendingSummary
                      getSideMenuPermissions={this.getSideMenuPermissions}
                    />
                  )}
                </Row>
              </div>
            </Container>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  suppressConfigVal: state?.app?.appConfigs?.Suppress_Setting,
  user: state.user,
  loadingNum: state.app.loadingNum,
  memberSummaryData: state.memberSummary,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setContentLoader: (num) => {
      dispatch(setContentLoader(num));
    },
    setMemberSummarySuccess: (payload) =>
      dispatch(setMemberSummarySuccess(payload)),
    setViewMemberInformationSuccess: (payload) =>
      dispatch(setViewMemberInformationSuccess(payload)),
    setMemberSummaryReject: () => setMemberSummaryReject,
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard),
);
